export default __webpack_public_path__ + "static/media/avatar.8fc421f8.jpg";